module.exports = __webpack_public_path__ + "static/media/building_icon.a69a09c3.svg";